module.exports = __webpack_public_path__ + "static/media/Aadi.0449fc55.JPG";